export default __webpack_public_path__ + "static/media/pantry2-after1.1d6f3688.jpg";